import Repository from './Repository';
import {RecipeNutrientOverride} from "@/models/Recipes/RecipeNutrientOverride";
import {ListResult} from "@/utils/API/ResultTypes/ListResult";
import { AxiosResponse } from 'axios';
import { MethodResult } from './ResultTypes/MethodResult';
import { Recipe } from '@/models/Recipes/Recipe';
import { resource } from "@/utils/API/RecipesRepository";

export function getNutrientOverrides(recipeId: number) {
  return Repository.get<ListResult<RecipeNutrientOverride>>(
    `${resource}/GetNutrientOverrides?recipeId=${recipeId}`,
    { withCredentials: true }
  );
}

export function applyNutrientOverrides(
  recipeId: number,
  changedOverrides: RecipeNutrientOverride[],
  removedOverrides: number[],
  servingQuantityOverride : number,
  servingUnitOverride: string
) {
  return Repository.post<
    { recipeId: number; changed: RecipeNutrientOverride[]; removed: number[] },
    AxiosResponse<MethodResult<Recipe>>
  >(
    `${resource}/ApplyNutrientOverrides`,
    { recipeId, changed: changedOverrides, removed: removedOverrides, servingQuantityOverride, servingUnitOverride},
    { withCredentials: true }
  );
}
